import React from 'react';
import { COUPON_DISCOUNT_TYPE } from '../../../../constants/service/app/couponConstants';
import { setNumberWithComma } from '../../../../lib/common';

const CouponBenefitInfo = (props) => {
  const { type, amount, minimumPurchasePrice, maxDiscountPrice } = props;
  let amountUnit = null;

  if (type === COUPON_DISCOUNT_TYPE.PRICE) amountUnit = '원';
  else if (type === COUPON_DISCOUNT_TYPE.RATE) amountUnit = '%';

  return (
    <div>
      <div>{setNumberWithComma(minimumPurchasePrice, '원')} 이상 구매시</div>
      <div>({setNumberWithComma(amount, amountUnit)} 할인 쿠폰)</div>
      {/*정율 할인일 경우 최대 할인금액 표시*/}
      {type === COUPON_DISCOUNT_TYPE.RATE ? <div>(최대 {setNumberWithComma(maxDiscountPrice, '원')})</div> : null}
    </div>
  );
};

export default CouponBenefitInfo;
